import gql from 'graphql-tag';

export const upsertWatchlistLevelConfigs = gql(`
  mutation UpsertWatchlistLevelConfigs($input: UpsertVisitorWatchlistLevelConfigInput!) {
    upsertWatchlistLevelConfigs(input: $input) {
      id
      organizationId
      level
      displayLevelText
      isNotificationsEnabled
      notificationTargets
      isWatchlistDisplayed
      isApprovalRequired
    }
  }`
);
